import { StructuredProcessArtifactType } from "./structuredProcess-artifactData";

export enum StepTypeEnum{
  CHAT = 1,
  COMPETENCIES = 2,
  INTRO_CONSENT = 3,
  EXTERNAL_INFO = 4
}

export interface StructuredProcessData{
    id: string;
    name: string;
    description: string;
    stages: StructuredProcessStageData[];
    introDoc: StructuredProcessIntroDoc | string;
}

export interface StructuredProcessStageData{
    id: string;
    idx: number;
    name: string;
    steps: StructuredProcessStepData[];
}

export interface StructuredProcessStepData{
    id: string;
    idx: number;
    stepType: StepTypeEnum;
    isEndOfProcess: boolean;
    header: string;
    content: string;
    stepUrl?: string;
    artifactType?: StructuredProcessArtifactType | "NONE";
}

type ArtifactTimestampMap = Partial<Record<StructuredProcessArtifactType, Date>>;

export interface StructuredProcessInstance {
  id: string;
  userId: string; // new
  processId: string;
  currentStepId: string;
  status: StructuredProcessInstanceStatusEnum;
  startedOn?: Date;
  completedOn?: Date;
  stagesInstances: StructuredProcessStageInstanceData[];
  artifactCreationRequestTimestamp?: ArtifactTimestampMap; // new
  artifactCreationTimestamp?: ArtifactTimestampMap;        // new
}

export interface StructuredProcessStageInstanceData {
  stageId: string;
  idx: number;
  status: StructuredProcessInstanceStatusEnum;
  startedOn?: Date;
  completedOn?: Date;
  stepsInstances: StructuredProcessStepInstanceData[];
}

export interface StructuredProcessStepInstanceData {
  stepId: string;
  idx: number;
  status: StructuredProcessInstanceStatusEnum;
  startedOn?: Date;
  completedOn?: Date;
}

export enum StructuredProcessInstanceStatusEnum{
    PENDING = 10,
    IN_PROGRESS = 20,
    COMPLETED = 30
}

export interface StructuredProcessIntroDoc {
  version: number;
  theme?: { accent?: string };
  header?: { title?: string; icon?: string };
  hero?: { type: "video" | "image"; src: string; alt?: string; aspect?: string };
  blocks: Array<
    | { type: "paragraph"; text: string }
    | { type: "callout"; tone?: "info"|"success"|"warn"; text: string }
    | { type: "section-title"; title: string; subtitle?: string }
    | { type: "steps"; items: { title: string; subtitle?: string; icon?: string }[] }
    | { type: "cta"; label: string; icon: string, action: "start" | "dismiss" }
  >;
}

export interface UserCompetencyData{
    competencyId: string,
    actionStyles: string[]
}

export interface UserCompetenciesData{
    userId: string,
    competencies: UserCompetencyData[],
    // set by the server when the results are saved (ISO date)
    completedAt?: string | null
}